import { useEffect, useState } from "react";
import useToggle from "../../hooks/useToggle";

const SkillInput = (props: any) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  useEffect(() => {
    props.setValue(`${props.name}`, isChecked.toString());
  }, [isChecked]);

  return (
    <label
      className={`container`}
      style={{
        width: `${props.width}px`,
      }}
    >
      <p className={`checkbox-value`}>{props.title}</p>
      <input
        type="checkbox"
        name={props.name}
        checked={isChecked}
        onChange={(e) => {
          setIsChecked((prevState) => !prevState); /* 
          console.log(e.target.checked); */
        }}
      />
      <span className="checkmark"></span>
    </label>
  );
};
export default SkillInput;
